<template>
    <div class="basket-notification">
        <div
            :class="`basket-notification__image basket-notification__image--${product.type}`"
            :style="imageWrapperStyle"
        >
            <img :src="imgSrc" :alt="product.actualItem.NAME">
        </div>
        <div class="basket-notification__content" v-if="product.type === 'coffee'">
            <h3 class="basket-notification__title">{{ product.actualItem.NAME }}</h3>

            <div class="basket-notification__meta">
                <p class="basket-notification__taste">{{ tastes }}</p>
                <p class="basket-notification__roaster">{{ roaster }}</p>

                <div class="basket-notification__weight-grinding">
                    <p class="basket-notification__weight" v-if="weight.value">Вес: <strong>{{ weight.value }} {{ weight.label }}</strong></p>
                    <p class="basket-notification__grinding" v-if="product.grinding">
                        Помол:
                        <strong>
                            <svg>
                                <use  v-bind="{'xlink:href': `/sprite.svg#icon-grinding-${product.grinding.XML_ID}`}"></use>
                            </svg>
                            <span>{{ product.grinding.VALUE }}</span>
                        </strong>
                    </p>
                    <p class="basket-notification__quantity-pack" v-if="quantityPack">Количество в упаковке: <strong>{{ quantityPack }} шт.</strong></p>
                </div>
                <div class="basket-notification__footer">
                    <div class="basket-notification__footer-item">
                        <p class="basket-notification__quantity">Количество: <strong>{{ product.quantity }} шт.</strong></p>
                        <p class="basket-notification__price">{{ (price * product.quantity).toLocaleString('ru-RU') }}.–</p>
                    </div>
                    <div class="basket-notification__footer-item basket-notification__footer-item--total">
                        <p>В корзине {{ productsInBasket }} {{ productsInBasketString }}</p>
                        <p>{{ productsInBasketSum }}.–</p>
                    </div>
                </div>
            </div>

        </div>
        <div class="basket-notification__content" v-if="product.type === 'equipment'">
            <h3 class="basket-notification__title">{{ product.actualItem.NAME }}</h3>

            <div class="basket-notification__meta">
                <div class="basket-notification__footer">
                    <p class="basket-notification__quantity">Количество: <strong>{{ product.quantity }} шт.</strong></p>
                    <p class="basket-notification__price">{{ (price * product.quantity).toLocaleString('ru-RU') }}.–</p>
                </div>
            </div>
        </div>
        <div class="basket-notification__content" v-if="product.type === 'event'">
            <h3 class="basket-notification__title" v-html="product.actualItem.NAME"></h3>

            <div class="basket-notification__meta">
                <div class="basket-notification__footer">
                    <p class="basket-notification__date">{{ date }}</p>
                    <p class="basket-notification__price">{{ price }}.–</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'basket-notification',

    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    methods: {
        getPluralString(number, words) {
            return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
        },
    },

    computed: {
        imgSrc() {
            return this.product.actualItem.PICTURE_SRC || window.specialtyApp.settings.defaultImages[0];
        },

        imageWrapperStyle() {
            if (this.product.type === 'equipment') {
                return {};
            }

            return {
                backgroundColor: this.product.actualItem.FILL_COLOR,
            };
        },

        price() {
            if (this.product.type === 'equipment') {
                return this.product.actualItem.CURRENT_PRICE.DISCOUNT_VALUE;
            }

            if (this.product.type === 'event') {
                return this.product.actualItem.CURRENT_PRICE.DISCOUNT_VALUE;
            }

            return this.product.offer?.CURRENT_PRICE.DISCOUNT_VALUE || this.product.actualItem.CURRENT_PRICE.DISCOUNT_VALUE;
        },

        weight() {
            // Удаляются лишние пробелы, иначе неверно к числу приводится
            const value = parseInt(this.product.offer?.PROPERTIES.VES_UPAKOVKI.VALUE.replace(/\s/, '') || 0, 10);

            if (value >= 1000) {
                return {
                    value: value / 1000,
                    label: 'кг',
                };
            }

            return {
                value,
                label: 'гр',
            };
        },

        quantityPack() {
            return this.product.offer?.PROPERTIES.SHTUK_V_UPAKOVKE?.VALUE;
        },

        tastes() {
            return Object.values(this.product.actualItem?.TASTES || {}).join(', ');
        },

        roaster() {
            return this.product.actualItem?.PROPERTIES?.POSTAVSHCHIK?.VALUE;
        },

        date() {
            return this.product.actualItem?.PROPERTIES?.DATA?.VALUE;
        },

        productsInBasket() {
            return this.product.basketData?.BASKET.ORDERABLE_BASKET_ITEMS_COUNT;
        },

        productsInBasketSum() {
            return this.product.basketData?.BASKET.allSum;
        },

        productsInBasketString() {
            return this.getPluralString(this.productsInBasket, ['товар', 'товара', 'товаров']);
        },
    },
};
</script>
